import { Link } from '@remix-run/react';

import Text from '~/components/Text';

import getNormalizedCategory from '~/utils/getNormalizedCategory';

import NavGroupPopover from './NavGroupPopover';

interface Props {
  children: React.ReactNode;
  subLinks: any;
  webTemplate: any;
}

const CategoriesPopover = ({ children, subLinks, webTemplate }: Props) => {
  const isCustomCategoriesEnabled = webTemplate.enable_customize_category_ids;
  const categoryIds = webTemplate.category_ids;

  return (
    <NavGroupPopover
      popoverContent={
        // biome-ignore lint/complexity/noUselessFragments: Otherwise it will error because of the ternary
        <>
          {subLinks.map((sublink: any) => {
            if (isCustomCategoriesEnabled && !categoryIds.includes(sublink.id)) {
              return null;
            }

            return (
              <Link
                key={sublink.id}
                className="flex rounded-wt px-3 py-2.5 hover:bg-black/5"
                to={`/t/${getNormalizedCategory(sublink.display)}`}
              >
                <Text as="span" type="title" theme="navs" className="text-xs sm:block">
                  {sublink.display}
                </Text>
              </Link>
            );
          })}
        </>
      }
    >
      {children}
    </NavGroupPopover>
  );
};

export default CategoriesPopover;
